import { trackBurgerClick, trackUserProfileClick } from 'analytics/trackers/header';
import { useNavigate } from 'react-router-dom';

import { PATHS } from 'constants/routerPaths';

import { useSidebar } from 'hooks';

import Burger from 'components/Burger';
import Logo from 'components/Logo';

import DefaultUserPic from 'assets/images/default-avatar.svg';

import * as S from './styled';

const Header = () => {
    const navigate = useNavigate();

    const { isOpen, toggle, close } = useSidebar();

    const onBurgerClick = () => {
        trackBurgerClick(!isOpen);
        toggle();
    };

    const handleRedirect = () => {
        trackUserProfileClick();
        navigate(PATHS.ACCOUNT_DEFAULT);
        close();
    };

    return (
        <S.HeaderContainer>
            <S.TitleContainer>
                <Burger onClick={onBurgerClick} isActive={isOpen} />
                <Logo />
            </S.TitleContainer>
            <S.AvatarImage onClick={handleRedirect}>
                <DefaultUserPic />
            </S.AvatarImage>
        </S.HeaderContainer>
    );
};

export default Header;
